<template>
	<div>
	<h5>{{ $t('routine_analyses.graphs.zone_activities_inspections', { zonename: zonename }) }}</h5>
		<div>
		<colchartzonesinspectionsquantities :inspections="inspections" :devices="devices" :properties="properties" :color="color" :orderby='orderby' :pest_id="pest_id"/>
	</div>
	</div>
</template>
<script>
export default {
	data: function () {
	    return {
	    	orderby: 'number'
	    }
	},
	props: {
        properties: Object,
        inspections: Array,
        devices: Object,
        color: String,
        zonename: String,
        pest_id: String
    },
}
</script>
<style scoped></style>